<!-- 首页右边框-主内容 -->
<template>
	<div>
		<el-row :gutter="24">
			<el-col :span="8">
				<div style="background: #fff;border-radius: 6px;width: 100%;height: 80px;justify-content: center;"
					class="d-flex align-items-center">
					<div style="width: 72%;margin-left: 6%;">
						<div style="font-size: 13px;margin-bottom: 4px;">客户总数</div>
						<div style="font-size: 16px;font-weight: 800;">{{kh_num}}</div>
					</div>
					<div style="width: 22%;">
						<img src="@/image/index1.png" style="width: 36px;height: 36px;">
					</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div style="background: #fff;border-radius: 6px;width: 100%;height: 80px;justify-content: center;"
					class="d-flex align-items-center">
					<div style="width: 72%;margin-left: 6%;">
						<div style="font-size: 13px;margin-bottom: 4px;">累计入仓总数</div>
						<div style="font-size: 16px;font-weight: 800;">{{kh_ljrc}}</div>
					</div>
					<div style="width: 22%;">
						<img src="@/image/index4.png" style="width: 36px;height: 36px;">
					</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div style="background: #fff;border-radius: 6px;width: 100%;height: 80px;justify-content: center;"
					class="d-flex align-items-center">
					<div style="width: 72%;margin-left: 6%;">
						<div style="font-size: 13px;margin-bottom: 4px;">累计出仓总数</div>
						<div style="font-size: 16px;font-weight: 800;">{{kh_ljcc}}</div>
					</div>
					<div style="width: 22%;">
						<img src="@/image/index4.png" style="width: 36px;height: 36px;">
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="24" style="margin-top: 10px;">
			<el-col :span="16">
				<div class="d-flex">
					<div style="background: #fff;border-radius: 6px;width: 100%;height: 220px;">
						<div ref="myCharpath1" style="width: 100%; height: 200px;"></div>
					</div>
				</div>
				<div class="d-flex" style="margin-top: 10px;">
					<div style="background: #fff;border-radius: 6px;width: 100%;height: 220px;">
						<div ref="myCharpath4" style="width: 100%; height: 220px;"></div>
					</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="d-flex">
					<div style="background: #fff;border-radius: 6px;width: 100%;height: 220px;">
						<div class="d-flex align-items-center" style="width: 100%;height: 60px;">
							<div style="font-size: 16px;margin-left: 10px;font-weight: 800;">累计入仓前五</div>
						</div>
						<div ref="myCharpath2" style="width: 100%; height: 210px;"></div>
					</div>
				</div>
				<div class="d-flex" style="margin-top: 10px;">
					<div style="background: #fff;border-radius: 6px;width: 100%;height: 220px;">
						<div class="d-flex align-items-center" style="width: 100%;height: 60px;">
							<div style="font-size: 16px;margin-left: 10px;font-weight: 800;">累计出仓前五</div>
						</div>
						<div ref="myCharpath3" style="width: 100%; height: 210px;"></div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'; // 引入 全局 公共数据
	import 'echarts/map/js/china.js';
	import moment from 'moment';
	import * as vueEcharts from "echarts";
	let echarts = require('echarts');
	export default {
		data() {
			return {
				year_mon:[],
				year_mons:[],
				day: '',
				myChart: null,
				moment,
				jrttl: 0,
				yuettl: 0,
				ccbfb: 0,
				kh_list: [],
				ck_list: [],
				kh_num: 0,
				kh_ljcc: 0,
				kh_ljrc: 0,
				kh_Chart: [],
				kh_Chart_name: [],
				dqsz: true,
				kh_ljrc5_num: [],
				kh_ljrc5_name: [],
				kh_ljcc5_num: [],
				kh_ljcc5_name: [],
				cka:[],
				ckb:[]
			};
		},

		computed: {
			// 引入store-modules的user模块里面的user(存储用户相关的数据)
			...mapState({
				user: state => state.user.user,
				navBar: state => state.menu.navBar
			})
		},
		// 生命周期
		created() {

		},
		// dom渲染完毕 mounted生命周期
		mounted() {

			this.drawLine();
			this.changeRecent()

			this.axios.post('/admin/kh_mblist', {year:this.year_mons}, {
					token: true
				})
				.then(res => {
					this.kh_num = res.data.data.num
					this.kh_list = res.data.data.list
					this.cka = res.data.data.cka
					this.ckb = res.data.data.ckb
					let ljrc = 0
					let ljcc = 0
					for (let c of this.kh_list) {
						ljrc += c.lj_rc
						ljcc += c.lj_cc
					}
					this.kh_ljrc = ljrc
					this.kh_ljcc = ljcc
					let rcdata = res.data.data.ljrc5
					let ccdata = res.data.data.ljcc5
					for (let rclist of rcdata) {
						this.kh_ljrc5_num.push(rclist.lj_rc)
						this.kh_ljrc5_name.push(rclist.name)
					}
					for (let cclist of ccdata) {
						this.kh_ljcc5_num.push(cclist.lj_cc)
						this.kh_ljcc5_name.push(cclist.name)
					}
					this.axios.post('/admin/sy_cklist', {}, {
							token: true
						})
						.then(res => {
							this.ck_list = res.data.data

							for (let i of this.ck_list) {
								let num = 0
								for (let ck of this.kh_list) {
									if (i.id == ck.ck_id) {
										num += 1
									}
								}
								this.kh_Chart.push(num)
								this.kh_Chart_name.push(i.name)
							}



						});



				});

		},
		// 画统计图方法
		methods: {
			clicktext() {
				if (this.dqsz == true) {
					this.dqsz = false
				} else {
					this.dqsz = true
				}
			},
			// 近15日
			changeRecent() {
				for (let i = 0; i < 12; i++) {
					this.year_mons.push(moment(new Date().getTime() - i * 1000 * 24 * 60 * 60 * 30).format('yy-MM-DD'))
					this.year_mon.push(moment(new Date().getTime() - i * 1000 * 24 * 60 * 60 * 30).format('YY-MM'))
				}
			},
			drawLine() {
				// 初始化echarts实例


				let myCharpath1 = echarts.init(this.$refs.myCharpath1);
				let myCharpath2 = echarts.init(this.$refs.myCharpath2);
				let myCharpath3 = echarts.init(this.$refs.myCharpath3);
				let myCharpath4 = echarts.init(this.$refs.myCharpath4);

				var that = this;
				setTimeout(function() {

					myCharpath1.setOption({
						title: {
							text: '客户归属图'
						},
						grid: {
							left: '3%',
							right: '7%',
							top: '20%',
							bottom:'2%',
							containLabel: true
						},
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow'
							}
						},
						xAxis: {
							type: 'value',
						},
						yAxis: {
							type: 'category',
							data: that.kh_Chart_name
						},
						series: [{
							type: 'bar',
							data: that.kh_Chart
						}]
					}),
					myCharpath2.setOption({
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow'
							}
						},
						grid: {
							left: '3%',
							right: '7%',
							top: '2%',
							containLabel: true
						},
						xAxis: {
							type: 'value'
						},
						yAxis: {
							type: 'category',
							data: that.kh_ljrc5_name
						},
						series: [{
							name: '累计入仓量',
							data: that.kh_ljrc5_num,
							type: 'bar'
						}]
					}),
					myCharpath3.setOption({
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow'
							}
						},
						grid: {
							left: '3%',
							right: '7%',
							top: '2%',
							containLabel: true
						},
						xAxis: {
							type: 'value'
						},
						yAxis: {
							type: 'category',
							data: that.kh_ljcc5_name
						},
						series: [{
							name: '累计出仓量',
							data: that.kh_ljcc5_num,
							type: 'bar'
						}]
					}),
					myCharpath4.setOption({
						title: {
							text: '近年客户增长走势图'
						},
						tooltip: {
							trigger: 'axis'
						},
						legend: {
							data: ['南海库', '石井库']
						},
						grid: {
							left: '3%',
							right: '2%',
							top: '20%',
							bottom:'2%',
							containLabel: true
						},
						xAxis: {
							type: 'category',
							data: that.year_mon
						},
						yAxis: {
							type: 'value'
						},
						series: [
							{
								name: '南海库',
								type: 'line',
								data: that.cka
							},
							{
								name: '石井库',
								type: 'line',
								data: that.ckb
							},
							
						]
					})
					
				}, 1000);
			},
		},
		beforeUnmount() {
			console.log('beforeUnmount')
			if (!myChart) {
				return
			}
			// window.removeEventListener('resize', this.__resizeHandler)
			myChart.dispose()
			let myChart = null
		},
	};
</script>

<style>
	.j-center {
		justify-content: center;
	}

	.a-center {
		align-items: center;
	}

	.j-j {
		flex-flow: column;
	}

	.txtx {
		font-size: 14px;
		font-weight: 800;
		color: #535353;
	}

	.gdt::-webkit-scrollbar {
		width: 0;
	}

	.aaa {
		background: #ff0000;
		color: #ff0000;
	}

	.bbb {
		color: #000000;
	}
</style>